/**
 * @generated SignedSource<<39d8172b81adb6f2fe97ebd6a667a0ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef$data = {
  readonly issue: {
    readonly timeTrackingField: {
      readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef";
};
export type originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef$key = {
  readonly " $data"?: originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "originalEstimate_nativeIssueTable_OriginalEstimateCell_fieldRef",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isInlineEditingEnabled",
                  "variableName": "isInlineEditingEnabled"
                }
              ],
              "kind": "FragmentSpread",
              "name": "originalEstimate_nativeIssueTable_OriginalEstimateTimeTrackingFieldCell_fieldRef"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraOriginalTimeEstimateField"
};

(node as any).hash = "a94aaa3cdea8a788b2dfde4610cb96bb";

export default node;
